export interface AllocationMatrixResponse {
  bookingUuid: string;
  data: AllocationMatrixData;
  versions: VersionsList[];
};
export interface AllocationMatrixData {
  guests: AllocationMatrixGuest[];
  breakdownItems: AllocationMatrixBreakdownItem[];
  allocations: AllocationsItem[];
};
export interface AllocationMatrixGuest {
  uuid: string;
  name: string;
  age?: number | null;
  isLeadGuest: boolean;
};

export enum EAllocationMatrixBreakdownPrductType {
  Accommodation = "Accommodation",
  Transfer = "Transfer",
  GroundService = "Ground Service",
  Bespoke = "Bespoke",
  Supplement = "Supplement"
}

export interface AllocationMatrixBreakdownItem {
  uuid: string;
  name: string;
  hotelName?: string;
  /** @enum {string} */
  productType: EAllocationMatrixBreakdownPrductType;
};

export interface AllocationsResponse {
  bookingUuid: string;
  hasManualUpdate?: boolean;
  version: number;
  createdAt: string;
  updatedAt: string;
  allocations: AllocationsItem[];
};

export interface AllocationsItem {
  guestUuid: string;
  breakdownItemUuid: string;
};

export interface VersionsList {
  version: number;
  timestamp: string;
  user?: {
    uuid: string;
    email: string;
  };
}